import { render } from "./LogoutComponent.vue?vue&type=template&id=127ae466&scoped=true&ts=true"
import script from "./LogoutComponent.vue?vue&type=script&lang=ts"
export * from "./LogoutComponent.vue?vue&type=script&lang=ts"

import "./LogoutComponent.vue?vue&type=style&index=0&id=127ae466&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-127ae466"]])

export default __exports__